<template>
<div class="chapter">
<div class="inner_page">
<div id="Zulu.html" xml:lang="en-GB" xmlns:xml="http://www.w3.org/XML/1998/namespace">
<div class="story">
<p class="dedication"><em class="italic">To my friend Fred Couderc<br/>
      whose giant’s wings taught me to fly<br/>
      and his wife, Laurence,<br/>
      a nervous glider.<br/></em><br/>
<em class="italic">Zone Libre,<br/>
      for the sound—full volume.</em></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?04ca2416